export default __webpack_public_path__ + "static/media/productivity.37d74737.svg";